(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 10404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61467);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33701);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35964);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74362);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6435);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["className", "children", "content", "placement", "strategy", "contentClassName", "zIndex", "portalTarget", "backgroundColor", "textColor", "disabled", "disableAutoHide", "lazy", "contentWidth", "contentPadding", "backgroundBorderColor", "disableArrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Tooltip = function Tooltip(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      content = _ref.content,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategyProp = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      contentClassName = _ref.contentClassName,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 30 : _ref$zIndex,
      portalTarget = _ref.portalTarget,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#080F3D' : _ref$backgroundColor,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'white' : _ref$textColor,
      disabled = _ref.disabled,
      disableAutoHide = _ref.disableAutoHide,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? true : _ref$lazy,
      contentWidth = _ref.contentWidth,
      _ref$contentPadding = _ref.contentPadding,
      contentPadding = _ref$contentPadding === void 0 ? '.7rem' : _ref$contentPadding,
      _ref$backgroundBorder = _ref.backgroundBorderColor,
      backgroundBorderColor = _ref$backgroundBorder === void 0 ? '#080F3D' : _ref$backgroundBorder,
      disableArrow = _ref.disableArrow,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useFloating = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useFloating */ .YF)({
    open: open,
    onOpenChange: function onOpenChange(value) {
      return disabled ? setOpen(false) : setOpen(disableAutoHide || value);
    },
    placement: placement,
    strategy: strategyProp,
    whileElementsMounted: _floating_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .autoUpdate */ .Me,
    middleware: [(0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .offset */ .cv)(5), (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .shift */ .uY)(), (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .arrow */ .x7)({
      element: arrowRef.current
    }), (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .hide */ .Cp)()]
  }),
      x = _useFloating.x,
      y = _useFloating.y,
      refs = _useFloating.refs,
      strategy = _useFloating.strategy,
      context = _useFloating.context,
      _useFloating$middlewa = _useFloating.middlewareData,
      _useFloating$middlewa2 = _useFloating$middlewa.arrow;

  _useFloating$middlewa2 = _useFloating$middlewa2 === void 0 ? {} : _useFloating$middlewa2;
  var arrowX = _useFloating$middlewa2.x,
      arrowY = _useFloating$middlewa2.y,
      hideMiddleware = _useFloating$middlewa.hide,
      floatingPlacement = _useFloating.placement;

  var _useTransitionStyles = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useTransitionStyles */ .Y_)(context),
      isMounted = _useTransitionStyles.isMounted,
      styles = _useTransitionStyles.styles;

  var hover = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useHover */ .XI)(context, {
    move: false,
    handleClose: (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .safePolygon */ .xp)()
  });
  var focus = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useFocus */ .KK)(context);
  var dismiss = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useDismiss */ .bQ)(context);
  var role = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useRole */ .qs)(context, {
    role: 'tooltip'
  });

  var _useInteractions = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useInteractions */ .NI)([hover, focus, dismiss, role]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function () {
    return {
      open: function open() {
        setOpen(true);
      },
      close: function close() {
        setOpen(false);
      }
    };
  });

  var tooltipStyles = _objectSpread({
    zIndex: zIndex,
    display: isMounted && hideMiddleware && !hideMiddleware.escaped && !hideMiddleware.referenceHidden || lazy ? 'block' : 'none',
    borderRadius: '.75rem',
    position: strategy,
    top: y !== null && y !== void 0 ? y : 0,
    left: x !== null && x !== void 0 ? x : 0,
    color: textColor,
    backgroundColor: backgroundColor,
    width: contentWidth,
    padding: contentPadding,
    border: "3px solid ".concat(backgroundBorderColor)
  }, styles);

  var arrowStyle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var arrowSide = {
      top: 'bottom',
      right: 'left',
      bottom: 'top',
      left: 'right'
    }[floatingPlacement.split('-')[0]];
    var targetArrowStyle = {
      position: 'absolute',
      width: '10px',
      height: '10px',
      backgroundColor: backgroundColor,
      left: arrowX !== null && arrowX !== void 0 ? arrowX : "".concat(arrowX, "px"),
      top: arrowY !== null && arrowY !== void 0 ? arrowY : "".concat(arrowY, "px")
    };

    if (!disableArrow) {
      var _objectSpread2;

      targetArrowStyle = _objectSpread(_objectSpread({}, targetArrowStyle), {}, (_objectSpread2 = {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread2, arrowSide, '-5px'), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread2, "transform", 'rotate(45deg)'), _objectSpread2));
    }

    return targetArrowStyle;
  }, [arrowX, arrowY, backgroundColor, disableArrow, floatingPlacement]);

  var getAllReferenceProps = function getAllReferenceProps() {
    return _objectSpread(_objectSpread({}, getReferenceProps()), {}, {
      ref: refs.setReference
    });
  };

  var renderChildren = function renderChildren() {
    if (typeof children === 'function') {
      return children(refs.setReference, getReferenceProps(), disabled);
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, props), getAllReferenceProps()), {}, {
      className: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_2__/* .buildClassesWithDefault */ .oJ)('inline-block', className),
      children: children
    }));
  };

  var renderTooltipContent = function renderTooltipContent() {
    if (disabled || lazy && !isMounted) {
      return;
    }

    if (typeof content === 'function') {
      return content(refs.setFloating, _objectSpread({
        style: tooltipStyles
      }, getFloatingProps()));
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", _objectSpread(_objectSpread({
      className: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_2__/* .buildClassesWithDefault */ .oJ)('tooltip', contentClassName),
      ref: refs.setFloating,
      style: tooltipStyles
    }, getFloatingProps()), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: "relative z-10",
        dangerouslySetInnerHTML: typeof content === 'string' ? {
          __html: content
        } : undefined,
        children: typeof content !== 'string' ? content : null
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        ref: arrowRef,
        style: arrowStyle
      })]
    }));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .FloatingPortal */ .ll, {
      root: portalTarget,
      children: renderTooltipContent()
    }), renderChildren()]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Tooltip));

/***/ }),

/***/ 18557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99535);
/* harmony import */ var _Layout_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34171);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(309);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46098);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


var _excluded = ["children", "redirect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var DefaultLayout = function DefaultLayout(_ref) {
  var children = _ref.children,
      redirect = _ref.redirect,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  (0,_hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(false, '/dashboard/invoices', redirect);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout_styles__WEBPACK_IMPORTED_MODULE_2__/* .DefaultLayoutGrid */ .Er, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X2, {
        justify: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg, {
          cols: 12,
          md: 8,
          lg: 6,
          xl: 5,
          children: children
        })
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);

/***/ }),

/***/ 34171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ DefaultLayoutGrid; },
/* harmony export */   "G$": function() { return /* binding */ AsideLayoutSidebar; },
/* harmony export */   "Ku": function() { return /* binding */ LayoutMain; },
/* harmony export */   "T9": function() { return /* binding */ AsideLayoutContainer; },
/* harmony export */   "TN": function() { return /* binding */ LayoutLoadingContainer; },
/* harmony export */   "g9": function() { return /* binding */ AsideLayoutContent; },
/* harmony export */   "oQ": function() { return /* binding */ AsideLayoutSidebarContainer; },
/* harmony export */   "rn": function() { return /* binding */ AsideLayoutContentContainer; },
/* harmony export */   "vC": function() { return /* binding */ DashboardLayoutContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99535);
/* harmony import */ var _config_config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56626);



var LayoutMain = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].main.withConfig */ .ZP.main.withConfig({
  displayName: "Layoutstyles__LayoutMain",
  componentId: "sc-mwnvy-0"
})(["", ""], {
  "height": "100%",
  "width": "100%"
});
var LayoutLoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__LayoutLoadingContainer",
  componentId: "sc-mwnvy-1"
})(["", ""], {
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center",
  "width": "100%",
  "height": "100vh"
});
var DefaultLayoutGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_base__WEBPACK_IMPORTED_MODULE_0__/* .Grid */ .rj).withConfig({
  displayName: "Layoutstyles__DefaultLayoutGrid",
  componentId: "sc-mwnvy-2"
})(["", ""], {
  "display": "flex",
  "minHeight": "100vh",
  "flexDirection": "column",
  "justifyContent": "center",
  "alignItems": "center"
});
/*
 DASHBOARD LAYOUT STYLES
*/

var DashboardLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__DashboardLayoutContainer",
  componentId: "sc-mwnvy-3"
})(["", " max-width:90rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
});
/*
 ASIDE LAYOUT STYLES
*/

var AsideLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContainer",
  componentId: "sc-mwnvy-4"
})(["", " grid-template-columns:", " auto"], {
  "display": "grid"
}, _config_config_json__WEBPACK_IMPORTED_MODULE_1__/* .theme.asideLayout.sidebarWidth */ .rS.SV.h);
var AsideLayoutSidebar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebar",
  componentId: "sc-mwnvy-5"
})(["", ""], {
  "display": "block",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
  "position": "relative",
  "maxHeight": "100vh"
});
var AsideLayoutSidebarContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebarContainer",
  componentId: "sc-mwnvy-6"
})(["", " ", ""], {
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "height": "100%",
  "overflowY": "auto"
}, function (_ref) {
  var $disableScroll = _ref.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContentContainer",
  componentId: "sc-mwnvy-7"
})(["", " ", ""], {
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem",
  "maxHeight": "100vh",
  "overflowY": "auto"
}, function (_ref2) {
  var $disableScroll = _ref2.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContent",
  componentId: "sc-mwnvy-8"
})(["", " width:45.875rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto"
});

/***/ }),

/***/ 309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./components/layout/Layout.styles.tsx
var Layout_styles = __webpack_require__(34171);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.styles.tsx

var ScrollTopButtonRoot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ScrollTopButtonstyles__ScrollTopButtonRoot",
  componentId: "sc-g7p5q0-0"
})(["", ""], {
  "zIndex": "50",
  "marginRight": "0.5rem",
  "position": "fixed",
  "bottom": "1.5rem",
  "right": "1rem",
  "width": "3.5rem",
  "height": "3.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(14, 40, 190, var(--tw-bg-opacity))",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(131, 166, 234, var(--tw-bg-opacity))"
  },
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center"
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaximizeIcon = function MaximizeIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 14C3.55228 14 4 14.4477 4 15V20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V15C2 14.4477 2.44772 14 3 14Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
    })]
  }));
};

MaximizeIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#ffffff",
  xmlns: "http://www.w3.org/2000/svg"
};




var ScrollTopButton = function ScrollTopButton(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  var onClick = function onClick(event) {
    props === null || props === void 0 ? void 0 : props.onClick(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollTopButtonRoot, _objectSpread(_objectSpread({}, props), {}, {
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaximizeIcon, {
      className: "fill-white"
    })
  }));
};

/* harmony default export */ var scroll_top_button_ScrollTopButton = (ScrollTopButton);
// EXTERNAL MODULE: ./config/config.json
var config = __webpack_require__(56626);
// EXTERNAL MODULE: ./hooks/invoice-upload/useInvoiceUploadContext.ts
var useInvoiceUploadContext = __webpack_require__(10459);
;// CONCATENATED MODULE: ./components/layout/Layout.tsx


function Layout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Layout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Layout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Layout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var LoadingSpinIcon = function LoadingSpinIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Layout_objectSpread(Layout_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "primary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.4C6.69807 2.4 2.4 6.69807 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "secondary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8 1.2C10.8 0.537258 11.3373 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 11.3373 0.537258 10.8 1.2 10.8C1.86274 10.8 2.4 11.3373 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2Z",
      fill: "white"
    })]
  }));
};

LoadingSpinIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#BBC9DE",
  xmlns: "http://www.w3.org/2000/svg"
};








var Layout = function Layout(_ref) {
  var children = _ref.children,
      headers = _ref.headers,
      titleProp = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      loading = _ref.loading;
  var title = "".concat(titleProp, " | ").concat(config/* appName */.DJ);
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();

  var _useInvoiceUploadCont = (0,useInvoiceUploadContext/* default */.Z)(),
      isFileDialogOpen = _useInvoiceUploadCont.isFileDialogOpen,
      setFileDialogOpen = _useInvoiceUploadCont.setFileDialogOpen;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    document.body.style.setProperty('background-color', (0,Helper/* getColorFromAppState */.QV)({
      theme: theme,
      $color: backgroundColor
    }));
  }, [backgroundColor, theme]);

  var onClickScrollTopButton = function onClickScrollTopButton(event) {
    event.preventDefault();
    setFileDialogOpen(true);
  };

  var renderLoading = function renderLoading() {
    return loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutLoadingContainer */.TN, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinIcon, {
        className: "animate-spin fill-primary-300 w-24 h-24"
      })
    });
  };

  var renderContent = function renderContent() {
    if (loading) {
      return renderLoading();
    }

    return children;
  };

  var renderScrollTopButton = function renderScrollTopButton() {
    var isOnInvoicesPage = router.pathname === '/dashboard/invoices';

    if (!isFileDialogOpen && !loading && isOnInvoicesPage) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Row */.X2, {
        justify: "end",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(scroll_top_button_ScrollTopButton, {
            onClick: onClickScrollTopButton
          })
        })
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      }), keywords && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: keywords.join(',')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "shortcut icon",
        type: "image/jpg",
        href: "/favicon.ico"
      }), headers]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutMain */.Ku, {
      children: renderContent()
    }), renderScrollTopButton()]
  });
};

/* harmony default export */ var layout_Layout = (Layout);

/***/ }),

/***/ 56609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ares_useAresDetails; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./services/ares/AresApiService.ts


var getAresDetails = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(axiosInstance, companyId) {
    var _yield$axiosInstance$, aresDetails;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosInstance.get('ares', {
              params: {
                companyId: companyId
              }
            });

          case 2:
            _yield$axiosInstance$ = _context.sent;
            aresDetails = _yield$axiosInstance$.data.data;
            return _context.abrupt("return", aresDetails);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAresDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useAxios.ts
var useAxios = __webpack_require__(75611);
;// CONCATENATED MODULE: ./hooks/api/ares/useAresDetails.ts






var useAresDetails = function useAresDetails(onFetch) {
  var axios = (0,useAxios/* default */.Z)();

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(),
      aresDetails = _useState2[0],
      setAresDetails = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      notFound = _useState3[0],
      setNotFound = _useState3[1];

  var resetAresDetails = (0,react.useCallback)(function () {
    setAresDetails(undefined);
    setNotFound(false);
  }, []);
  var fetchAresDetails = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(companyId) {
      var throwError,
          response,
          _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              throwError = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              setIsLoading(true);
              setNotFound(false);
              _context.prev = 3;
              _context.next = 6;
              return getAresDetails(axios, companyId);

            case 6:
              response = _context.sent;
              console.log(response);
              setNotFound(false);
              setAresDetails(response);
              onFetch === null || onFetch === void 0 ? void 0 : onFetch(response);
              return _context.abrupt("return", response);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              setAresDetails(undefined);
              setNotFound(true);

              if (!throwError) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", Promise.reject(_context.t0));

            case 20:
              _context.prev = 20;
              setIsLoading(false);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14, 20, 23]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [axios, onFetch]);
  return {
    isLoading: isLoading,
    notFound: notFound,
    resetAresDetails: resetAresDetails,
    aresDetails: aresDetails,
    fetchAresDetails: fetchAresDetails
  };
};

/* harmony default export */ var ares_useAresDetails = (useAresDetails);

/***/ }),

/***/ 46098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _auth_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var useMiddleware = function useMiddleware() {
  var onlyLogged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var redirectTo = arguments.length > 1 ? arguments[1] : undefined;
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      push = _useRouter.push;

  var _useCurrentUser = (0,_auth_auth__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUser */ .xJ)(),
      isLogged = _useCurrentUser.isLogged,
      isReady = _useCurrentUser.isReady;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      allowed = _useState[0],
      setAllowed = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!enabled || !isReady) {
      return;
    }

    var disallow = !isLogged && onlyLogged || isLogged && !onlyLogged;
    setAllowed(!disallow);

    if (disallow && redirectTo) {
      push(redirectTo);
    }
  }, [isLogged, onlyLogged, redirectTo, push, isReady, enabled]);
  return {
    allowed: allowed
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMiddleware);

/***/ }),

/***/ 44128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ registration; }
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(41696);
// EXTERNAL MODULE: ./components/layout/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(18557);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./auth/auth.ts + 2 modules
var auth = __webpack_require__(98541);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/base/tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(10404);
// EXTERNAL MODULE: ./hooks/api/ares/useAresDetails.ts + 1 modules
var useAresDetails = __webpack_require__(56609);
// EXTERNAL MODULE: ./node_modules/validator/index.js
var validator = __webpack_require__(48966);
var validator_default = /*#__PURE__*/__webpack_require__.n(validator);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/app/registration/RegistrationCard.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var LoadingSpinIcon = function LoadingSpinIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "primary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.4C6.69807 2.4 2.4 6.69807 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "secondary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8 1.2C10.8 0.537258 11.3373 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 11.3373 0.537258 10.8 1.2 10.8C1.86274 10.8 2.4 11.3373 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2Z",
      fill: "white"
    })]
  }));
};

LoadingSpinIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#BBC9DE",
  xmlns: "http://www.w3.org/2000/svg"
};


var QuestionCircleIcon = function QuestionCircleIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "#0E28BE"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.11899 10.5634L9.11925 10.5626C9.23988 10.2011 9.41243 9.90366 9.63938 9.67429C9.86013 9.4512 10.1248 9.24899 10.4324 9.06721C10.6211 8.9499 10.7903 8.81909 10.9405 8.67489C11.0874 8.53379 11.2034 8.37201 11.289 8.18912C11.373 8.00954 11.4158 7.80941 11.4158 7.58711C11.4158 7.32057 11.3519 7.0953 11.2279 6.90704C11.1017 6.71543 10.9338 6.56818 10.7224 6.46448L10.7209 6.46373L10.7209 6.46372C10.5124 6.35706 10.2785 6.30286 10.017 6.30286C9.78128 6.30286 9.55679 6.35082 9.34262 6.44686C9.13318 6.54077 8.959 6.6875 8.81955 6.88971L8.81915 6.89028L8.81915 6.89028C8.68306 7.08471 8.60094 7.34098 8.57909 7.66543L8.57281 7.75871H8.47932H7H6.89596L6.90008 7.65475C6.92339 7.06676 7.07532 6.56381 7.36054 6.15081C7.64353 5.73785 8.0179 5.42546 8.48171 5.21446L8.48195 5.21435C8.94708 5.00428 9.45928 4.9 10.017 4.9C10.6261 4.9 11.1639 5.01204 11.6277 5.23945C12.0907 5.46328 12.4524 5.77917 12.7097 6.18734C12.9709 6.59356 13.1 7.06617 13.1 7.60143C13.1 7.9685 13.0415 8.30267 12.9226 8.60249L12.9225 8.60284C12.8043 8.89769 12.6353 9.16127 12.4159 9.39305M9.11899 10.5634L12.3431 9.32458M9.11899 10.5634C9.00102 10.9271 8.94061 11.4094 8.93407 12.0061H8.93406M9.11899 10.5634L8.93406 12.0061M12.4159 9.39305C12.4159 9.39314 12.4158 9.39324 12.4157 9.39333L12.3431 9.32458M12.4159 9.39305C12.416 9.39296 12.4161 9.39286 12.4162 9.39276L12.3431 9.32458M12.4159 9.39305C12.2013 9.62329 11.9441 9.8262 11.6451 10.0022M12.3431 9.32458C12.1354 9.54733 11.8856 9.74463 11.5937 9.91647M11.6451 10.0022C11.6454 10.0021 11.6456 10.0019 11.6459 10.0018L11.5937 9.91647M11.6451 10.0022C11.6449 10.0024 11.6446 10.0025 11.6444 10.0026L11.5937 9.91647M11.6451 10.0022L11.5937 9.91647M10.4258 12.0072C10.4258 12.0572 10.3852 12.0979 10.3351 12.0979H9.12476C9.07467 12.0979 9.03406 12.0572 9.03406 12.0072C9.04055 11.4153 9.10057 10.9443 9.21411 10.5943C9.3309 10.2442 9.49635 9.96102 9.71046 9.74463C9.92457 9.52824 10.1825 9.33095 10.4842 9.15274C10.6788 9.03182 10.854 8.89658 11.0097 8.74702C11.1655 8.59745 11.2887 8.42562 11.3796 8.2315C11.4704 8.03739 11.5158 7.82259 11.5158 7.58711C11.5158 7.3039 11.4477 7.05887 11.3114 6.85203C11.1752 6.64519 10.9935 6.48608 10.7664 6.3747C10.5426 6.26014 10.2928 6.20286 10.017 6.20286C9.76723 6.20286 9.52879 6.25378 9.3017 6.35561C9.07461 6.45744 8.88646 6.61655 8.73723 6.83294C8.588 7.04614 8.50203 7.3214 8.47932 7.65871H7.10008C7.10003 7.66003 7.09997 7.66135 7.09992 7.66267L7 7.65871V7.55871H7.00529C7.04048 7.02941 7.18632 6.57905 7.44282 6.20764C7.71533 5.80986 8.07543 5.50915 8.52311 5.30549C8.97405 5.10183 9.47202 5 10.017 5C10.614 5 11.1363 5.10979 11.5839 5.32936C12.0316 5.54574 12.3788 5.84964 12.6253 6.24105C12.8751 6.62928 13 7.08274 13 7.60143C13 7.95784 12.9432 8.27924 12.8297 8.56563L10.4258 12.0072ZM10.4258 12.0072H10.5258M10.4258 12.0072H10.5258M8.93406 12.0061V12.0072M8.93406 12.0061V12.0072M8.93406 12.0072C8.93406 12.1125 9.01944 12.1979 9.12476 12.1979H10.3351M8.93406 12.0072L10.3351 12.1979M10.3351 12.1979C10.4404 12.1979 10.5258 12.1125 10.5258 12.0072M10.3351 12.1979L10.5258 12.0072M10.995 10.51C10.9952 10.5099 10.9953 10.5097 10.9954 10.5096L10.9221 10.4415L10.9947 10.5103C10.9948 10.5102 10.9949 10.5101 10.995 10.51ZM9.0127 14.7945L9.01331 14.7951C9.22336 14.9977 9.47696 15.1 9.76886 15.1C9.96413 15.1 10.144 15.0528 10.3062 14.9573C10.466 14.8632 10.5946 14.7372 10.6908 14.5802C10.7916 14.4177 10.8421 14.2387 10.8421 14.0453C10.8421 13.7564 10.7331 13.5079 10.5195 13.3051C10.31 13.0998 10.0581 12.9955 9.76886 12.9955C9.47656 12.9955 9.22288 13.0997 9.013 13.3054C8.80268 13.5084 8.69562 13.7568 8.69562 14.0453C8.69562 14.3368 8.80245 14.5883 9.0127 14.7945Z",
      fill: "#0E28BE",
      stroke: "#0E28BE",
      strokeWidth: "0.2"
    })]
  }));
};

QuestionCircleIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};







var RegistrationCard = function RegistrationCard() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('registration'),
      t = _useTranslation.t;

  var _useSignUp = (0,auth/* useSignUp */.QS)(),
      signUp = _useSignUp.signUp,
      isLoading = _useSignUp.isLoading;

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(es/* object */.Ry({
      name: es/* string */.Z_().required(t('registrationPage.form.name.validation.required')),
      email: es/* string */.Z_().test('is-email', t('registrationPage.form.email.validation.notValid'), function (value) {
        return validator_default().isEmail(value || '');
      }).required(t('registrationPage.form.email.validation.required')),
      companyName: es/* string */.Z_().required(t('registrationPage.form.companyName.validation.required')),
      street: es/* string */.Z_().required(t('registrationPage.form.street.validation.required')),
      buildingNumber: es/* string */.Z_().required(t('registrationPage.form.buildingNumber.validation.required')),
      city: es/* string */.Z_().required(t('registrationPage.form.city.validation.required')),
      postalCode: es/* string */.Z_().required(t('registrationPage.form.postalCode.validation.required')),
      companyId: es/* string */.Z_().required(t('registrationPage.form.cin.validation.required')),
      agreement: es/* boolean */.O7().isTrue(t('registrationPage.form.acceptTermsAndConditions.validation.required')),
      password: es/* string */.Z_().required(t('registrationPage.form.password.validation.required'))
    })),
    reValidateMode: 'onChange'
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.formState.errors,
      setError = _useForm.setError,
      setValue = _useForm.setValue,
      clearErrors = _useForm.clearErrors;

  var _useAresDetails = (0,useAresDetails/* default */.Z)(function (_ref) {
    var companyName = _ref.companyName,
        street = _ref.street,
        buildingNumber = _ref.buildingNumber,
        city = _ref.city,
        postalCode = _ref.postalCode;
    clearErrors(['companyName', 'street', 'city', 'postalCode']);
    setValue('companyName', companyName);
    setValue('street', street);
    setValue('buildingNumber', buildingNumber);
    setValue('city', city);
    setValue('postalCode', postalCode);
  }),
      fetchAresDetails = _useAresDetails.fetchAresDetails,
      isAresLoading = _useAresDetails.isLoading,
      aresDetailsNotFound = _useAresDetails.notFound;

  var debouncedFetchAresDetails = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var value;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = _ref2.target.value;

              if (!(value.length >= 8)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", fetchAresDetails(value, false));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function debouncedFetchAresDetails(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getFieldError = function getFieldError(path) {
    var _errors$path;

    return (_errors$path = errors[path]) === null || _errors$path === void 0 ? void 0 : _errors$path.message;
  };

  var submit = function submit(data) {
    return !aresDetailsNotFound && signUp(data).catch(function (error) {
      return (0,Helper/* handleFormErrorsFromAxios */.LR)(error, setError);
    });
  };

  var renderTitle = function renderTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledH, {
      children: t('registrationPage.title')
    });
  };

  var renderHeader = function renderHeader() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "/logo.svg",
      alt: "Logo"
    });
  };

  var renderDescription = function renderDescription() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(_StyledP, {
      children: [t('registrationPage.login.description'), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledLink, {
          children: t('registrationPage.login.link')
        })
      })]
    });
  };

  var renderAcceptTermsAndConditionsLabel = function renderAcceptTermsAndConditionsLabel() {
    var link = function link(url) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledLink2, {
        underline: false,
        bold: false,
        href: url
      });
    };

    var components = {
      termsLink: link('/terms-and-condition'),
      gdprLink: link('/gdpr')
    };
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledSpan, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledTrans, {
        t: t,
        i18nKey: "registrationPage.form.acceptTermsAndConditions.label",
        components: components
      })
    });
  };

  var renderCompanyIdTooltip = function renderCompanyIdTooltip() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      zIndex: 999,
      placement: "right",
      contentWidth: "19em",
      contentPadding: "0.5rem",
      content: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t('registrationPage.form.cin.tooltip')
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionCircleIcon, {})
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* CenteredFormCard */.TY, {
    onSubmit: handleSubmit(submit),
    submitLabel: t('registrationPage.form.submit'),
    loading: isLoading,
    title: renderTitle(),
    header: renderHeader(),
    description: renderDescription(),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Grid */.rj, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(base/* Row */.X2, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.name.label'),
            invalidMessage: getFieldError('name')
          }, register('name')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.cin.label'),
            invalidMessage: aresDetailsNotFound ? t('registrationPage.form.cin.validation.notFound') : getFieldError('companyId'),
            leftIcon: isAresLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinIcon, {
              className: "animate-spin fill-primary-300"
            }),
            rightIcon: renderCompanyIdTooltip()
          }, register('companyId', {
            onChange: debouncedFetchAresDetails
          })))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.companyName.label'),
            disabled: true,
            invalidMessage: getFieldError('companyName')
          }, register('companyName')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 8,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.street.label'),
            disabled: true,
            invalidMessage: getFieldError('street')
          }, register('street')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.buildingNumber.label'),
            disabled: true,
            invalidMessage: getFieldError('buildingNumber')
          }, register('buildingNumber')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.city.label'),
            disabled: true,
            invalidMessage: getFieldError('city')
          }, register('city')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.postalCode.label'),
            disabled: true,
            invalidMessage: getFieldError('postalCode')
          }, register('postalCode')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.email.label'),
            invalidMessage: getFieldError('email')
          }, register('email')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('registrationPage.form.password.label'),
            type: "password",
            invalidMessage: getFieldError('password')
          }, register('password')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Checkbox */.XZ, _objectSpread({
            label: renderAcceptTermsAndConditionsLabel(),
            invalidMessage: getFieldError('agreement')
          }, register('agreement')))
        })]
      })
    })
  });
};

/* harmony default export */ var registration_RegistrationCard = (RegistrationCard);

var _StyledH = (0,styled_components_browser_esm/* default */.ZP)("h1").withConfig({
  displayName: "RegistrationCard___StyledH",
  componentId: "sc-a2zqyd-0"
})({
  "fontSize": "3.75rem",
  "lineHeight": "4.538rem",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});

var _StyledP = (0,styled_components_browser_esm/* default */.ZP)("p").withConfig({
  displayName: "RegistrationCard___StyledP",
  componentId: "sc-a2zqyd-1"
})({
  "fontSize": "1rem",
  "lineHeight": "1.21rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});

var _StyledLink = (0,styled_components_browser_esm/* default */.ZP)(base/* Link */.rU).withConfig({
  displayName: "RegistrationCard___StyledLink",
  componentId: "sc-a2zqyd-2"
})({
  "fontSize": "1rem",
  "lineHeight": "1.21rem"
});

var _StyledLink2 = (0,styled_components_browser_esm/* default */.ZP)(base/* Link */.rU).withConfig({
  displayName: "RegistrationCard___StyledLink2",
  componentId: "sc-a2zqyd-3"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.059rem",
  "fontWeight": "500"
});

var _StyledSpan = (0,styled_components_browser_esm/* default */.ZP)("span").withConfig({
  displayName: "RegistrationCard___StyledSpan",
  componentId: "sc-a2zqyd-4"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.059rem",
  "fontWeight": "500"
});

var _StyledTrans = (0,styled_components_browser_esm/* default */.ZP)(esm/* Trans */.cC).withConfig({
  displayName: "RegistrationCard___StyledTrans",
  componentId: "sc-a2zqyd-5"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.059rem",
  "fontWeight": "500"
});
;// CONCATENATED MODULE: ./pages/registration/index.tsx





var RegistrationPage = function RegistrationPage() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('registration'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
    title: t('registrationPage.title'),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(registration_RegistrationCard, {})
  });
};

var __N_SSP = true;
/* harmony default export */ var registration = (RegistrationPage);

/***/ }),

/***/ 94485:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration",
      function () {
        return __webpack_require__(44128);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [535,491,966,467,774,888,179], function() { return __webpack_exec__(94485); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);